import type { Environment } from '../app/core/tokens/app.tokens';
import {
  CONTENT_LANGUAGES,
  OPERATOR_LANGUAGES,
} from '../app/features/shell/models/supported-language.model';

/**
 * Ciò che non cambia da un ambiente all'altro: le lingue servite, i limiti degli allegati, le durate.
 * Sta qui una volta sola perché i due file d'ambiente sono alternativi — la build ne sostituisce uno
 * con l'altro — e due copie della stessa lista divergono alla prima modifica fatta su una sola.
 *
 * Quello che invece appartiene al singolo ambiente non ha un difetto qui: lo dichiara il file che lo
 * descrive, così un valore mancante si vede dove si configura.
 */
export const environmentDefaults: Omit<Environment, 'production'> = {
  // Percorsi relativi: e' la forma per cui il portale e' disegnato — SPA e BFF dietro lo stesso host,
  // quindi stessa origine — ed e' quella che vale in locale, dove il dev server fa da proxy verso il BFF
  // (`proxy.conf.json`). Un deployment che serve le due parti da host diversi dichiara l'indirizzo del
  // BFF nel `config.json` pubblicato accanto all'artefatto
  // (`core/configuration/runtime-environment.ts`), e quello vince su questi due valori.
  apiUrl: '/api/v1',
  hubUrl: '/hubs',
  defaultLanguage: 'en',
  // Le lingue che questa build sa servire: dizionari, bandiere e dati di formattazione stanno nel
  // bundle, quindi l'elenco e' suo. Quale sottoinsieme se ne offre lo dice il tenant, che arriva dal BFF
  // (`core/tenant`) — qui non c'e' un elenco da tenere allineato a quello.
  contentLanguages: CONTENT_LANGUAGES,
  operatorLanguages: OPERATOR_LANGUAGES,
  translationTimeoutMs: 10_000,
  attachmentMaxSizeBytes: 10_485_760,
  attachmentAcceptedImageTypes: ['image/jpeg', 'image/png', 'image/webp'],
  attachmentAcceptedDocumentTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
  ],
};
